import { PathOptions } from "leaflet";

export const polos_empresariais = (): PathOptions => {
  return {
    color: "#34495e",
    weight: 2,
    opacity: 0.9,
    fillColor: "#f1c40f",
    fillOpacity: 0.85,
    radius: 7,
  } as PathOptions;
};
